import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyCustom' })
export class CurrencyCustomPipe implements PipeTransform {

  transform(value: any, symbol: string): string {

    if (!value && !symbol) {
      return '';
    }

    const locale = 'pt-BR'
    const decimalFormat = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

    if(symbol) {

      return symbol.concat('\u00a0').concat(decimalFormat.format(value));
    } else {
      return symbol.concat('\u00a0').concat("0,00");
    }
  }

}
